<template>
  <base-card tabled>
    <template v-slot:header>
      <base-card-heading>Fees</base-card-heading>
      <div>
        <base-button secondary small @click="add">Add Fee</base-button>
      </div>
    </template>
    <template v-if="fees.length">
      <base-table>
        <thead>
          <tr>
            <th>Fee</th>
            <th>Calculation</th>
            <th>Amount</th>
            <th>Added to Loan</th>
            <th>Date Charged</th>
            <th></th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="(fee, key) in fees" :key="key">
            <td>
              <base-field row>
                <base-select v-model="fees[key].fee" placeholder="fee" required source="fees" />
              </base-field>
            </td>
            <td>
              <base-field row>
                <base-select v-model="fees[key].calculation" placeholder="calculation" required source="feeTypes" />
              </base-field>
            </td>
            <td>
              <base-field :addon-left-icon="getAmountBaseIconLeft(key)" :addon-right-icon="getAmountBaseIconRight(key)" row>
                <base-input v-model="fees[key].amount" numeric placeholder="amount" required />
              </base-field>
            </td>
            <td>
              <base-field row>
                <base-select v-model="fees[key].loan" :options="options" placeholder="loan" />
              </base-field>
            </td>
            <td>
              <base-field row>
                <base-select v-model="fees[key].chargeOn" placeholder="charge" requried source="feeChargeOptions" />
              </base-field>
              <base-field v-if="fees[key].chargeOn === 'OnDate'" addon-left-icon="calendar-alt" row>
                <base-input v-model="fees[key].chargeAt" datepicker placeholder="charge date" />
              </base-field>
            </td>
            <td>
              <base-button v-tooltip="'Delete Fee'" icon-left="trash" small @click="remove(key)" />
            </td>
          </tr>
        </tbody>
      </base-table>
    </template>
    <template v-else>
      <p class="mb-0 p-4">
        You haven't added any fees yet, <a href="#" @click.prevent="add">add one</a> now?
      </p>
    </template>
  </base-card>
</template>

<script>
import { mapGetters } from 'vuex'

export default {
  created () {
    this.assign()
  },

  data: () => ({
    fees: []
  }),

  name: 'FacilityFees',

  props: {
    loans: Array,
    value: Array
  },

  computed: {
    options () {
      const options = [{
        text: 'Not Added',
        value: ''
      }]

      this.loans.forEach((loan, key) => options.push({
        text: `${this.$_.upperFirst(this.$formatting.toWordsOrdinal(key + 1))} Loan`,
        value: key.toString()
      }))

      return options
    },

    ...mapGetters({
      schema: 'core/facility-fees/schema'
    })
  },

  methods: {
    add () {
      const fee = this.$_.clone(this.schema)

      this.fees.push(fee)
    },

    assign () {
      this.fees = this.$_.cloneDeep(this.value) || []
      this.fees.forEach((fee, index) => {
        this.loans.forEach((loan, key) => {
          if (fee.loan === loan._id) {
            this.fees[index].loan = key.toString()
          }
        })
      })
    },

    getAmountBaseIconLeft (key) {
      if (this.fees[key].calculation === 'FixedFee') {
        return 'pound-sign'
      }
    },

    getAmountBaseIconRight (key) {
      if (this.fees[key].calculation !== 'FixedFee') {
        return 'percent'
      }
    },

    remove (index) {
      this.$dialog.confirm('Are you sure you want to remove this fee?', () => {
        this.fees.splice(index, 1)
      })
    }
  },

  watch: {
    fees: {
      deep: true,
      handler () {
        this.$emit('input', this.fees)
      }
    }
  }
}
</script>
